import { HashLink as Link } from "react-router-hash-link";
import { Icon } from "@iconify/react/dist/iconify.js";
import noscrollOffset from "../../components/noscrollOffset";
import scrollToTop from "../../components/scroll-to-top";

const Links = () => {
  return (
    <>
      <div className="linktree-container">
        <img
          src="https://dye493vmtifvj.cloudfront.net/aws-logos/full/purple.png"
          alt="full logo"
        />
        <div className="sect">
          <h5>Work with us</h5>
          <div className="links">
            <Link
              to="/intro-form"
              target="blank"
              onClick={() => {
                scrollToTop();
              }}
            >
              <Icon
                icon="icon-park-outline:click"
                className="icon"
                style={{ transform: "scaleX(-1)" }}
              />
              <span>I need a website</span>
            </Link>
            <Link>
              <Icon icon="qlementine-icons:calendar-16" className="icon" />{" "}
              <span>Schedule a meeting</span>
            </Link>
            <Link to="/contact#contactform" scroll={noscrollOffset}>
              <Icon icon="majesticons:chat-2-line" className="icon" />{" "}
              <span>Send us a message</span>
            </Link>
          </div>
        </div>{" "}
        <div className="sect">
          <h5>Learn more about us</h5>
          <div className="links">
            <Link
              to="/projects"
              onClick={() => {
                scrollToTop();
              }}
            >
              <Icon
                icon="ix:project-arrow-left"
                className="icon"
                style={{ transform: "scaleX(-1)" }}
              />
              <span>Our projects</span>
            </Link>
            <Link
              to="/landing-pages"
              onClick={() => {
                scrollToTop();
              }}
            >
              <Icon
                icon="ic:outline-miscellaneous-services"
                className="icon"
                style={{ transform: "scaleX(-1)" }}
              />{" "}
              <span>Our Services</span>
            </Link>
            <Link
              to="/"
              onClick={() => {
                scrollToTop();
              }}
            >
              <Icon icon="mdi:web" className="icon" />{" "}
              <span>Visit our Website</span>
            </Link>
          </div>
        </div>{" "}
        <div className="sect">
          <h5>Keep up with us</h5>
          <div className="links">
            <a href="https://www.instagram.com/acrylicwebstudios?igsh=MXRtbXJvbjV0Y29kdA%3D%3D&utm_source=qr">
              <Icon icon="mdi:instagram" className="icon" />{" "}
              <span>Instagram</span>
            </a>
            <a href="https://www.tiktok.com/@acrylicwebstudios_?_t=ZN-8yjzXsUZC8k&_r=1">
              <Icon icon="ic:baseline-tiktok" className="icon" />
              <span>TikTok</span>
            </a>
            <a href="https://x.com/AcrylicWeb?t=TvG8qFsvWTvSGsBhsQXFew&s=08">
              <Icon icon="prime:twitter" className="icon" />
              <span>Twitter</span>
            </a>
            <a href="https://x.com/AcrylicWeb?t=TvG8qFsvWTvSGsBhsQXFew&s=08">
              <Icon icon="mdi:linkedin" className="icon" />
              <span>LinkedIn</span>
            </a>
            <a href="https://github.com/acrylicweb">
              <Icon icon="mdi:github" className="icon" />
              <span>Github</span>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Links;
